import styled from 'styled-components';
import { Icon } from '../../stories/atoms';

export const StyledCategoryContainer = styled.div<{ isMobile?: boolean }>`
  display: flex;
  padding: ${({ theme: { spacing }, isMobile }) => (isMobile ? spacing(2, 4) : spacing(2, 8))};
  justify-content: space-between;
  > div {
    display: flex;
  }
`;

export const StyledIcon = styled(Icon)<{ isSelected: boolean }>`
  width: ${({ theme: { spacing } }) => spacing(8)};
  height: ${({ theme: { spacing } }) => spacing(8)};
  padding: ${({ theme: { spacing } }) => spacing(2)};
  border-radius: ${({ theme: { spacing } }) => spacing(2)};
  background-color: ${({ isSelected, theme: { color, palette } }) =>
    isSelected
      ? palette.mode === 'dark'
        ? color.secondaryTextGray
        : color.backgroundSelected
      : palette.mode === 'light'
      ? color.borderGray
      : color.backgroundSelectedHover};
  justify-content: center;
`;

export const StyledSwitchWrapper = styled.div<{ isMobile?: boolean }>`
  display: flex;
  align-items: center;
  padding: ${({ theme: { spacing }, isMobile }) => isMobile && spacing(2, 0)};
`;
